<template>
    <div>
        <div class="row">
            <div class="col-12 col-md-8">
                <ob1-liens
                    class="p-0 text-start"
                    is-button
                    :modal-id="modalId"
                    data-bs-toggle="modal"
                    :text="odrName"
                />
            </div>
            <div class="col-12 col-md-4 fw-bold amount text-end">
                <span>{{ odrAmount }}</span>
            </div>
        </div>
        <promo-odr-popin
            :odr-amount-in-cents="odrAmountInCents"
            :odr-start-date="odrStartDate"
            :odr-end-date="odrEndDate"
            :odr-link="odrLink"
            :modal-id="modalId"
            :promo-odr-messages="promoOdrMessages"
        />
    </div>
</template>

<script>

import PromoOdrPopin from "./PromoOdrPopin.vue";

export default {
    components: {PromoOdrPopin},
    props: {
        modalId: {
            type: String,
            required: true
        },
        odrName: {
            type: String,
            required: true
        },
        odrAmountInCents: {
            type: Number,
            required: true
        },
        odrStartDate: {
            type: String,
            required: false,
            default: undefined
        },
        odrEndDate: {
            type: String,
            required: false,
            default: undefined
        },
        odrLink: {
            type: String,
            required: false,
            default: undefined
        },
        promoOdrMessages: {
            type: Object,
            required: true
        }
    },
    computed: {
       odrAmount(){
            return this.promoOdrMessages.odrAmount.replace("{0}", PriceFormatter.formatEurosWithSpace(this.odrAmountInCents / 100, false).toString())
        }
    },
    method: {

    }
}
</script>
<style scoped lang="scss">

@media (min-width: 736px) {
    .amount {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
